import { getRequest } from '../../../services/httpService';
import { SemenProcessing } from '../SemenProcessing/SemenProcessingHelper';









export function getIUIDetailsUrl(Id: string): string {
  return `/iui/cycle/${Id}/`; 
}
export function getIUIDetails(Id: string): Promise<SemenProcessing[]> {
  return getRequest(getIUIDetailsUrl(Id), { responseType: 'json' });
}